import { render, staticRenderFns } from "./FormCreateAccount.vue?vue&type=template&id=7fe6b746&"
import script from "./FormCreateAccount.vue?vue&type=script&lang=js&"
export * from "./FormCreateAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports